import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { RiErrorWarningLine } from "react-icons/ri";
import { withNamespaces } from "react-i18next";
import { useHistory } from "react-router-dom";

const CancelConfirmationModal = ({ isEdit, t, isOpen, toggle }) => {
    const history = useHistory();

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                <div className="d-flex justify-content-start align-items-center">
                    <RiErrorWarningLine className="me-2 text-warning" size={22} />
                    {t(isEdit ? 'Cancel Product Editing' : 'Cancel Product Creation')}
                </div>
            </ModalHeader>
            <ModalBody>
                <p className="mb-2 fw-semibold">
                    {t(
                        isEdit ?
                            'Are you sure you want to cancel editing this product?' :
                            'Are you sure you want to cancel this process?'
                    )}
                </p>
                <p className="text-muted mb-0">
                    {isEdit ? (
                        t('Any changes you’ve made will not be saved. You can continue editing if you wish.')
                    ) : (
                        <>
                            {t('Any information you’ve entered so far will be lost.')}
                            {t('You can go back and continue creating the product if you wish.')}
                        </>
                    )}
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t(isEdit ? 'Continue Editing' : 'Continue Creating')}
                </Button>
                <Button
                    color="danger"
                    onClick={() => history.push({
                        search: 'tab=products'
                    })}
                >
                    {t(isEdit ? 'Discard Changes & Exit' : 'Discard & Exit')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    CancelConfirmationModal
);
